import { ListOfOrganizations } from "./Organizations.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum OrganizationsActionsTypes {
  CREATE_REQUEST = "organizations/CREATE_REQUEST",
  CREATE_FAIL = "organizations/CREATE_FAIL",
  CREATE_SUCCESS = "organizations/CREATE_SUCCESS",
  DISMISS_MESSAGE = "organizations/DISMISS_MESSAGE",
  EDIT_REQUEST = "organizations/EDIT_REQUEST",
  EDIT_FAIL = "organizations/EDIT_FAIL",
  EDIT_SUCCESS = "organizations/EDIT_SUCCESS",
  LIST_REQUEST = "organizations/LIST_REQUEST",
  LIST_FAIL = "organizations/LIST_FAIL",
  LIST_SUCCESS = "organizations/LIST_SUCCESS"
}

export interface OrganizationsState {
  isLoadingList: boolean;
  list: ListOfOrganizations;
  message?: IMessageBar;
}

interface CreateRequest {
  type: OrganizationsActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: OrganizationsActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: OrganizationsActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: OrganizationsActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: OrganizationsActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: OrganizationsActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: OrganizationsActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: OrganizationsActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: OrganizationsActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: OrganizationsActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfOrganizations;
  };
}

export type OrganizationsReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
